import { IRouteType } from '../../types'
import mwbPAndL from '../common/pnl'
import mwbPAndLRanking from '../common/pnlRankings'
import mwbBenchmarking from './mwbBenchmarking'
import mwbBonusTracker from './mwbBonusTracker'
import mwbDriveThru from './mwbDriveThru'
import mwbGuestConfig from './mwbGuest'
import mwbHome from './mwbHome'
import mwbProduct from './mwbProduct'
import mwbSystemwideOverview from './mwbSystemwideOverview'
import mwbOriginalCorporatePagesConfig from './originalCorporatePages'

export const routes: IRouteType[] = [
  {
    title: 'Corporate',
    children: [
      {
        title: 'Expo AI',
        link: '/:brand/expo_ai',
        useOriginal: true,
      },
      {
        title: 'Ops Scorecard',
        link: '/:brand/ops_scorecard',
      },
      {
        title: 'Systemwide Overview',
        link: '/:brand/systemwide_overview',
        default: true,
      },
      {
        title: 'Rankings',
        link: '/:brand/rankings',
        useOriginal: true,
      },
      {
        title: 'Flash',
        link: '/:brand/flash',
        useOriginal: true,
      },
      {
        title: 'Salesmanship',
        link: '/:brand/corporate_salesmanship',
        useOriginal: true,
      },
      {
        title: 'Loss Prevention',
        link: '/:brand/corporate_loss_prevention',
        useOriginal: true,
      },
      {
        title: 'Inventory',
        link: '/:brand/corporate_inventory',
        useOriginal: true,
      },
      {
        title: 'Guest',
        link: '/:brand/corporate_guest',
        default: true,
      },
      {
        title: 'Delivery',
        link: '/:brand/corporate_delivery',
        useOriginal: true,
      },
      {
        title: 'Drive Thru',
        link: '/:brand/drive_thru',
      },
      {
        title: 'Product',
        collapsible: true,
        children: [
          {
            title: 'Sales Mix',
            link: '/:brand/corporate_product',
            useOriginal: true,
          },
          {
            title: 'Item by Daypart',
            link: '/:brand/item_by_daypart',
          },
          {
            title: 'Item Velocity',
            link: '/:brand/item_velocity',
          },
          {
            title: 'Trending',
            link: '/:brand/product_trending',
          },
          {
            title: 'Product Insight',
            link: '/:brand/product_insight',
          },
          {
            title: 'Product Insight QA',
            link: '/:brand/product_insight_qa',
          },
        ],
      },
    ],
  },
  {
    title: 'Store',
    children: [
      {
        title: 'Home',
        link: '/:brand/scorecard',
      },
      {
        title: 'Guest',
        link: '/:brand/guest',
        default: true,
      },
    ],
  },
  {
    title: 'P&L',
    children: [
      {
        title: 'Expo AI P&L',
        link: '/:brand/pnl',
      },
      {
        title: 'Expo AI P&L Rankings',
        link: '/:brand/pnl-rankings',
      },
    ],
  },
  {
    title: 'Benchmarking',
    children: [
      {
        title: 'Metrics',
        link: '/:brand/benchmarking_metrics',
      },
      {
        title: 'Product Mix',
        link: '/:brand/benchmarking_product_mix',
      },
      {
        title: 'Campaign',
        link: '/:brand/benchmarking_marketing_campaign',
      },
    ],
  },
]

export default [
  mwbSystemwideOverview,
  mwbGuestConfig,
  mwbProduct,
  mwbHome,
  mwbPAndL({
    brand: 'mwb-pnl-permission',
    autoComplete: true,
    netProfitId: '41',
    dateOptions: {
      types: [
        'week',
        'period',
        'quarter',
        'year',
        'last_week',
        'this_week',
        'yesterday',
        'trailing_7_days',
        'trailing_90_days',
        'custom',
      ],
      endDate: undefined,
    },
  }),
  mwbPAndLRanking({
    brand: 'mwb-pnl-permission',
    dateOptions: {
      types: [
        'week',
        'period',
        'quarter',
        'year',
        'last_week',
        'this_week',
        'yesterday',
        'trailing_7_days',
        'trailing_90_days',
        'custom',
      ],
      endDate: undefined,
    },
  }),
  mwbOriginalCorporatePagesConfig,
  mwbBonusTracker,
  mwbDriveThru,
  mwbBenchmarking,
]
